(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('DocumentParameterDefinitionsEditController', DocumentParameterDefinitionsEditController);

    DocumentParameterDefinitionsEditController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'DocumentParameterDefinitionsService',
    	'InstanceService', '$state', '$cookies', '$stateParams', '$mdDialog', 'PlagiatValidationService'];

    function DocumentParameterDefinitionsEditController (Principal, Auth, JhiLanguageService, $translate, DocumentParameterDefinitionsService,
    		InstanceService, $state, $cookies, $stateParams,  $mdDialog, PlagiatValidationService) {
        var vm = this;
        vm.instance = InstanceService.instance().lang;
        vm.theme = $cookies.get('plagiat-theme');
        vm.timezone = InstanceService.instance().timezoneDocuments;
        moment.locale(vm.instance);
        vm.key = $stateParams.key;
        vm.selected = [];
        vm.save = save;
        vm.backToMainList = backToMainList;
        vm.form = {
        		id: $stateParams.parameterId
        }
        
        vm.dopadeTypes = DocumentParameterDefinitionsService.getDopadeTypes();
        
        getForm($stateParams.parameterId);
        
        function backToMainList(){
        	$state.go('document-parameter-definitions');
        }
        
        function getForm(parameterId){
        	DocumentParameterDefinitionsService.getForm(parameterId).then(function(response){
        		vm.form = response.data;
        	});
        }
        
        function save(form, ev){
        	DocumentParameterDefinitionsService.edit(form).then(function(){
        		backToMainList();
        		
        		$mdDialog.show(
                        $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("document.parameter.definition.form.edit.msg"))
                        .ariaLabel('msgSuccess')
                        .ok('Ok')
                        .targetEvent(ev)
                        );
        	}, function(response){
        		PlagiatValidationService.getModalError(response.data);
        	})
        }
         
    }
})();
